export default "__VITE_ASSET__2VnYdQSv__"